var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('admin-wrapper',{attrs:{"title-translation-path":"navbar.parcelReportSettings","has-buttons":false,"disabled":true,"moduleEnabler":_vm.moduleEnabler}})}
var staticRenderFns = []

export { render, staticRenderFns }